<template>
  <CRow>
    <CCol col="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Fast Lane
        </CCardHeader>
        <CCardBody>
          <div class="d-flex align-items-center justify-content-between flex-wrap" style="gap:12px;">
            <div>
              <div><strong>Fast Lane Feature Toggle</strong></div>
              <small class="text-muted">Turn Fast Lane UI and backend checks on or off without removing the code.</small>
            </div>
            <div>
              <CButton
                size="sm"
                @click="setFastLaneEnabled(1)"
                :disabled="fastLaneToggleLoading"
                :color="fastLaneEnabled === 1 ? 'success' : 'outline-success'"
              >
                On
              </CButton>
              <CButton
                size="sm"
                class="ml-1"
                @click="setFastLaneEnabled(0)"
                :disabled="fastLaneToggleLoading"
                :color="fastLaneEnabled === 0 ? 'danger' : 'outline-danger'"
              >
                Off
              </CButton>
            </div>
          </div>
        </CCardBody>
      </CCard>
      </transition>

      <transition name="slide">
      <CCard>
        <CCardHeader>
          Additional Charges/Discounts
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Charge</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            v-if="!loading"
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #per_piece="{item}">
            <td>
              {{item.per_piece ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #percentage_of_whole_order="{item}">
            <td>
              {{item.percentage_of_whole_order ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #fastlane_charge="{item}">
            <td>
              {{item.fastlane_charge ? 'Yes' : 'No'}}
            </td>
          </template>
          <template #location_options="{item}">
            <td>
              <div style="width:100%;float:left;" v-for="v in item.location_options">{{v}}</div>
            </td>
          </template>
          <template #actions="{item, index}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item )">Edit</CButton>
              <CButton size="sm" class="ml-1" color="danger" @click="remove( item, index )">Remove</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        <small-loader v-else />
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Charge"
        :show.sync="addModal"
      >
        <CForm v-if="addModal">
          <CInput
            :lazy="false"
            label="Charge Name"
            :value.sync="form.charge_name"
            placeholder="Charge Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Charge Code"
            :value.sync="form.charge_code"
            placeholder="Charge Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Price / Percentage"
            :value.sync="form.price"
            placeholder="Price or %"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Use NetSuite For Calculation (this is for discounts)</label>
            <div>
              <CButton size="sm" @click="form.use_netsuite_for_calculation = 1" :color="form.use_netsuite_for_calculation === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.use_netsuite_for_calculation = 0" style="margin-left:5px;" :color="form.use_netsuite_for_calculation === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Programs This Applies To (leave blank for all)?</label>
            <multiselect v-model="form.programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
          </div>
          <CInput
            :lazy="false"
            label="NetSuite Internal ID"
            :value.sync="form.internal_id"
            placeholder="ID"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Price Per Piece?</label>
            <div>
              <CButton size="sm" @click="form.per_piece = 1" :color="form.per_piece === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.per_piece = 0" style="margin-left:5px;" :color="form.per_piece === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Percentage Of Whole Order?</label>
            <div>
              <CButton size="sm" @click="form.percentage_of_whole_order = 1" :color="form.percentage_of_whole_order === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.percentage_of_whole_order = 0" style="margin-left:5px;" :color="form.percentage_of_whole_order === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Program Min Quantity Check?</label>
            <div>
              <CButton size="sm" @click="form.min_quantity_check = 1" :color="form.min_quantity_check === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.min_quantity_check = 0" style="margin-left:5px;" :color="form.min_quantity_check === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Fast Lane Charge?</label>
            <div>
              <CButton size="sm" @click="form.fastlane_charge = 1" :color="form.fastlane_charge === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.fastlane_charge = 0" style="margin-left:5px;" :color="form.fastlane_charge === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Location(s) Available</label>
            <div>
              <v-select :options="locationOptions" multiple v-model="form.location_options"></v-select>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="store(form, 'add')" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Charge"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            label="Charge Name"
            :value.sync="editForm.charge_name"
            placeholder="Charge Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Charge Code"
            :value.sync="editForm.charge_code"
            placeholder="Charge Code"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <CInput
            :lazy="false"
            label="Price / Percentage"
            :value.sync="editForm.price"
            placeholder="Price or %"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Use NetSuite For Calculation (this is for discounts)?</label>
            <div>
              <CButton size="sm" @click="editForm.use_netsuite_for_calculation = 1" :color="editForm.use_netsuite_for_calculation === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.use_netsuite_for_calculation = 0" style="margin-left:5px;" :color="editForm.use_netsuite_for_calculation === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Programs This Applies To (leave blank for all)</label>
            <multiselect v-if="programs" v-model="editForm.programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
          </div>
          <CInput
            :lazy="false"
            label="NetSuite Internal ID"
            :value.sync="editForm.internal_id"
            placeholder="ID"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Price Per Piece?</label>
            <div>
              <CButton size="sm" @click="editForm.per_piece = 1" :color="editForm.per_piece === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.per_piece = 0" style="margin-left:5px;" :color="editForm.per_piece === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Percentage Of Whole Order?</label>
            <div>
              <CButton size="sm" @click="editForm.percentage_of_whole_order = 1" :color="editForm.percentage_of_whole_order === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.percentage_of_whole_order = 0" style="margin-left:5px;" :color="editForm.percentage_of_whole_order === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Program Min Quantity Check?</label>
            <div>
              <CButton size="sm" @click="editForm.min_quantity_check = 1" :color="editForm.min_quantity_check === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.min_quantity_check = 0" style="margin-left:5px;" :color="editForm.min_quantity_check === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;padding-top:15px;">
            <label>Fast Lane Charge?</label>
            <div>
              <CButton size="sm" @click="editForm.fastlane_charge = 1" :color="editForm.fastlane_charge === 1 ? 'success': 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="editForm.fastlane_charge = 0" style="margin-left:5px;" :color="editForm.fastlane_charge === 0 ? 'danger': 'outline-danger'">No</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-bottom:15px;">
            <label>Location(s) Available</label>
            <div>
              <v-select :options="locationOptions" multiple v-model="editForm.location_options"></v-select>
            </div>
          </div>
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="store(editForm, 'edit')" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect';
var methods = {}

methods.getData = function () {
  let self = this
  axios.get(this.$apiAdress + '/api/additional_charges?include_fastlane=1&token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
    self.loading = false
  }).catch(function (error) {
    console.log(error)
  });
}

methods.getFastLaneToggle = function () {
  return axios.get(this.$apiAdress + '/api/feature_toggles/fast_lane?token=' + localStorage.getItem('api_token')).then((response) => {
    this.fastLaneEnabled = parseInt(response.data.enabled || 0)
    return response
  })
}

methods.setFastLaneEnabled = function (enabled) {
  this.fastLaneToggleLoading = true
  return axios.post(this.$apiAdress + '/api/feature_toggles/fast_lane?token=' + localStorage.getItem('api_token'), {
    enabled: enabled ? 1 : 0
  }).then((response) => {
    this.fastLaneEnabled = parseInt(response.data.enabled || 0)
  }).finally(() => {
    this.fastLaneToggleLoading = false
  })
}

methods.getPrograms = function () {
  axios.get(this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
    .then(response => this.programs = response.data)
    .catch(error => console.error(error));
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.remove = function (item, index) {
  let self = this
  axios.post(this.$apiAdress + '/api/additional_charges/remove?token=' + localStorage.getItem('api_token'), item)
  .then(function (response) {
    self.items.splice(index, 1)
  }).catch(function (error) {
    console.log(error)
  })
}

methods.edit = function (val) {
  this.editForm = val
  this.editModal = true
  // this.$router.push({ path: '/programs/' + val.program_id + '/edit' })
}

methods.store = function (form, type) {
  let self = this;
  console.log(form)
  axios.post(   this.$apiAdress + '/api/additional_charges/store?token=' + localStorage.getItem("api_token"),
    form
  )
  .then(function (response) {
    if (type == 'add') {
      if (self.items) {
        self.items.push(response.data)
      } else {
        self.items = [response.data]
      }
    }
      self.form = self.getForm()
      self.editForm = ''
      self.addModal = false
      self.editModal = false
      self.loading = true
      setTimeout(function () {
        self.loading = false
      }, 500)
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    additonal_charges_id: '',
    charge_name: '',
    charge_code: '',
    price: '',
    per_piece: 1,
    percentage_of_whole_order: 0,
    location_options: '',
    internal_id: '',
    programs: [],
    min_quantity_check: 0,
    use_netsuite_for_calculation: 0,
    fastlane_charge: 0
  }
}

export default {
  name: 'AdditionalCharges',
  components: {Multiselect},
  data() {
    return {
      items: [],
      loading: true,
      fields: ['charge_name', 'charge_code', 'price', 'per_piece', 'percentage_of_whole_order', 'fastlane_charge', 'location_options', 'internal_id', 'actions'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      programs: [],
      editModal: false,
      locationOptions: [
        'Undervisor',
        'Back on customer hangtag',
        'Back of the Imperial hangtag',
        'Where convenient swift tack'
      ],
      fastLaneEnabled: 0,
      fastLaneToggleLoading: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getFastLaneToggle()
    this.getData()
    this.getPrograms()
  }
}
</script>
